import React from "react";
import Class2Table from "./Class2Table.js";
import Class1Table from "./Class1Table.js";


export default function ResultDisplayClass2(props) {
    const resOneAndTwo = props.res.filter(r => r.display_class === 1 || r.display_class === 2);
    return (
            resOneAndTwo.length > 1 ? <Class2Table res={resOneAndTwo} address={props.address} /> : <Class1Table res={resOneAndTwo} address={props.address} />  
    )
}